export const salesOrderAdjustments = (items) => {
  const adjustments = items?.reduce((acc, currItem) => {
    const { originalQuantity, quantity } = currItem;
    if (originalQuantity && quantity !== originalQuantity) {
      acc.push({ ...currItem });
    }
    return acc;
  }, []);
  const hasAdjustments = !!adjustments?.length;
  return { hasAdjustments, adjustments };
};
